var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg66(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right arrow / 24 / Outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5427 11.2895L9.88267 5.63955C9.7897 5.54582 9.6791 5.47143 9.55724 5.42066C9.43538 5.36989 9.30468 5.34375 9.17267 5.34375C9.04066 5.34375 8.90995 5.36989 8.78809 5.42066C8.66623 5.47143 8.55563 5.54582 8.46267 5.63955C8.27642 5.82691 8.17188 6.08036 8.17188 6.34455C8.17188 6.60873 8.27642 6.86219 8.46267 7.04955L13.4127 12.0495L8.46267 16.9995C8.27642 17.1869 8.17188 17.4404 8.17188 17.7045C8.17188 17.9687 8.27642 18.2222 8.46267 18.4095C8.55528 18.504 8.66573 18.5792 8.7876 18.6307C8.90948 18.6822 9.04036 18.709 9.17267 18.7095C9.30497 18.709 9.43586 18.6822 9.55773 18.6307C9.67961 18.5792 9.79005 18.504 9.88267 18.4095L15.5427 12.7595C15.6442 12.6659 15.7252 12.5523 15.7806 12.4258C15.836 12.2993 15.8646 12.1627 15.8646 12.0245C15.8646 11.8864 15.836 11.7498 15.7806 11.6233C15.7252 11.4968 15.6442 11.3832 15.5427 11.2895Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg66);
export default __webpack_public_path__ + "static/media/svg66.1ebc671b89c44abb60fca9d5d1e2b1e3.svg";
export { ForwardRef as ReactComponent };